export default "__VITE_ASSET__762aa28f__"